var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "send-email-dialog",
          attrs: {
            title: "发送邮件",
            visible: _vm.sendSupplierDialog,
            width: "50%",
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
            "append-to-body": "",
            "custom-class": "email-dialog-custom",
          },
          on: {
            "update:visible": function ($event) {
              _vm.sendSupplierDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "email-container" }, [
            _c("div", { staticClass: "recipient-row" }, [
              _c("span", { staticClass: "label" }, [_vm._v("收件人：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.ruleForm.email)),
              ]),
            ]),
            _c("div", { staticClass: "email-row" }, [
              _c("span", { staticClass: "label" }, [_vm._v("主题：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v("优联制卡需求单ID" + _vm._s(_vm.ruleForm.id)),
              ]),
            ]),
            _c("div", { staticClass: "requirements-container" }, [
              _c("div", { staticClass: "requirements-header" }, [
                _vm._v("制定要求如下："),
              ]),
              _c("div", { staticClass: "requirements-content" }, [
                _c("div", { staticClass: "requirements-row" }, [
                  _c("span", { staticClass: "requirement-item" }, [
                    _c("span", { staticClass: "requirement-label" }, [
                      _vm._v("印刷类型："),
                    ]),
                    _c("span", { staticClass: "requirement-value" }, [
                      _vm._v(_vm._s(_vm.ruleForm.print_type_str || "")),
                    ]),
                  ]),
                  _c("span", { staticClass: "requirement-item" }, [
                    _c("span", { staticClass: "requirement-label" }, [
                      _vm._v("印刷物料："),
                    ]),
                    _c("span", { staticClass: "requirement-value" }, [
                      _vm._v(_vm._s(_vm.ruleForm.material_type_str || "")),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "requirements-row" }, [
                  _c("span", { staticClass: "requirement-item" }, [
                    _c("span", { staticClass: "requirement-label" }, [
                      _vm._v("工艺材质："),
                    ]),
                    _c("span", { staticClass: "requirement-value" }, [
                      _vm._v(_vm._s(_vm.ruleForm.craft_type_str || "")),
                    ]),
                  ]),
                  _c("span", { staticClass: "requirement-item" }, [
                    _c("span", { staticClass: "requirement-label" }, [
                      _vm._v("规格："),
                    ]),
                    _c("span", { staticClass: "requirement-value" }, [
                      _vm._v(_vm._s(_vm.ruleForm.attribute_str || "")),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "requirements-row" }, [
                  _c("span", { staticClass: "requirement-item" }, [
                    _c("span", { staticClass: "requirement-label" }, [
                      _vm._v("是否加急："),
                    ]),
                    _c("span", { staticClass: "requirement-value" }, [
                      _vm._v(
                        _vm._s(_vm.ruleForm.is_urgent === "1" ? "是" : "否")
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "table-container" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      data: _vm.ruleForm.bracn_office_data,
                      "header-cell-style": {
                        background: "#FAFAFA",
                        color: "#333333",
                      },
                      "tooltip-effect": "dark",
                      "show-overflow-tooltip": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "begin_code",
                        label: "起始卡序号",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "end_code",
                        label: "结束卡序号",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "make_count",
                        label: "数量",
                        width: "100px",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "address",
                        label: "寄送地址",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "card_type_des",
                        label: "卡类型",
                        align: "center",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "email-row" }, [
              _c("span", { staticClass: "label" }, [_vm._v("附件：")]),
              _c("span", { staticClass: "value attachment" }, [
                _vm._v(_vm._s(_vm.ruleForm.card_name || "")),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "dialog-note" }, [
            _vm._v("注：邮件发送成功后，短信发送文件查看密码"),
          ]),
          _c(
            "div",
            { staticClass: "dialog-button" },
            [
              _c(
                "el-button",
                {
                  staticClass: "send-button",
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.send },
                },
                [_vm._v("发送")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }